(() => {
  'use strict';

  const KEY = '__LP_CONVERSIONS_FOOTER_V1__';

  if (window[KEY]) {
    window[KEY].init(document);
    return;
  }

  const instances = new WeakMap();

  class LPConversionsFooter {
    constructor(root) {
      this.root = root;
      this.abortController = new AbortController();
      this.accordions = Array.from(root.querySelectorAll('[data-lpcf-accordion]'));
      this.bind();
    }

    bind() {
      this.accordions.forEach((accordion) => {
        accordion.addEventListener(
          'toggle',
          () => {
            if (!accordion.open || window.innerWidth > 820) return;

            this.accordions.forEach((other) => {
              if (other !== accordion) other.open = false;
            });
          },
          { signal: this.abortController.signal }
        );
      });
    }

    destroy() {
      this.abortController.abort();
      instances.delete(this.root);
    }
  }

  function init(scope = document) {
    scope.querySelectorAll?.('[data-lpcf]').forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new LPConversionsFooter(root));
    });
  }

  function boot() {
    init(document);

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.('[data-lpcf]')
        ? event.target
        : event.target.querySelector?.('[data-lpcf]');

      if (root) instances.get(root)?.destroy();
    });
  }

  window[KEY] = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
